import Cookies from "js-cookie";
import { toast } from "@/controllers/alert";
const authenticated = async (props, data) => {
  try {
    // a fresh login lets "every_login" announcements show again
    sessionStorage.removeItem("announcements_shown");
    sessionStorage.removeItem("announcements_checked");
    await TokenHandle(props, data);
    await fetchUser(props);
    await fetchRole(props);
  } catch (error) {
    console.log(error);
  }
};
const setNewUser = async (props, token) => {
  try {
    Cookies.set("token", token, { expires: 30 });
    Cookies.set("isLoggedIn", true, { expires: 30 });
    await props.$store.commit("auth/SET_TOKEN", token);
    props.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await setUser(props);
  } catch (error) {
    console.log(error);
  }
};

const fetchUser = async (props) => {
  try {
    const { data } = await props.$http.get("me");
    if (data.status) {
      await props.$store.commit("auth/SET_USER", data.data);
      localStorage.setItem("user", JSON.stringify(data.data));
      if (data.data.role === 2) {
        localStorage.setItem("currency", data.data.stores.currency);
        await props.$router.push("/sale");
      } else {
        await props.$router.push("/administrator/index");
      }
    }
  } catch (error) {
    console.log(error);
  }
};

const fetchRole = async (props) => {
  try {
    const roles = [
      "show_cost",
      "show_profit",
      "show_revenue",
      "can_delete_ticket",
    ];
    const { data } = await props.$http.get(`has_multiple_role?roles=${roles}`);
    if (data.status && data.data) {
      // Extract menu codes from the API response
      const permissions = data.data
        .map((item) => item.menu?.code)
        .filter((code) => code); // Filter out any undefined/null values

      // Store permissions in localStorage
      localStorage.setItem("user_permissions", JSON.stringify(permissions));

      return data.data;
    } else {
      // If no permissions found, store empty array (more secure default)
      localStorage.setItem("user_permissions", JSON.stringify([]));
    }
  } catch (error) {
    console.log(error);
    // On error, store empty array (more secure default)
    localStorage.setItem("user_permissions", JSON.stringify([]));
  }
};

const setUser = async (props) => {
  try {
    const { data } = await props.$http.get("me");
    if (data.status) {
      await props.$store.commit("auth/SET_USER", data.data);
      localStorage.setItem("user", JSON.stringify(data.data));
      if (
        data.data &&
        data.data.stores &&
        data.data.stores.is_decimal !== null &&
        data.data.stores.is_decimal !== undefined
      ) {
        localStorage.setItem("is_decimal", data.data.stores.is_decimal);
      }
    }
  } catch (error) {
    console.log("error", error);
  }
};

const checkToken = async (props) => {
  // check token expiration by comparing the current time and the expiration time in local storage
  const expired_at = localStorage.getItem("expired_at");
  const now = new Date();
  const expired = new Date(expired_at);
  const diff = (expired.getTime() - now.getTime()) / 1000 / 60;
  // check if token near to expiration in 2 minutes
  const reNewToken = process.env.VUE_APP_RENEW_TOKEN || 2;
  const min = parseInt(reNewToken);
  // convert to number
  if (diff < min) {
    // block the request until the token is refreshed and then release it with the new token
    await refreshToken(props);
  }
};

const refreshToken = async (props) => {
  try {
    const { data } = await props.$http.post("refresh");
    if (data.status) {
      const msg = "Renew token successfully";
      toast(props, msg, "info");
      await setUser(props);
      await TokenHandle(props, data);
      window.location.reload();
    }
  } catch (error) {
    console.log("error", error);
  }
};

const TokenHandle = async (props, data) => {
  try {
    const token = data.access_token;
    const expired_at = data.expires_in;
    localStorage.setItem("expired_at", expired_at);
    Cookies.set("token", token, { expires: 30 });
    Cookies.set("isLoggedIn", true, { expires: 30 });
    await props.$store.commit("auth/SET_TOKEN", token);
    props.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * Check if user has a specific permission
 * @param {string} permissionCode - The permission code to check (e.g., "show_cost", "show_profit")
 * @returns {boolean} - Returns true if permission exists, false otherwise
 */
const hasPermission = (permissionCode) => {
  try {
    const permissionsJson = localStorage.getItem("user_permissions");
    if (!permissionsJson) {
      return false; // No permissions stored, return false (more secure default)
    }
    const permissions = JSON.parse(permissionsJson);
    if (!Array.isArray(permissions)) {
      return false; // Invalid format, return false
    }
    return permissions.includes(permissionCode);
  } catch (error) {
    console.log("error checking permission", error);
    return false; // On error, return false (more secure default)
  }
};

export {
  authenticated,
  fetchUser,
  setUser,
  setNewUser,
  checkToken,
  fetchRole,
  hasPermission,
};
